'use client'

import { AccessoriesPage } from '@/screens/Accessories'
import { BrandsItem } from '@/screens/Home/page/types/types'

import { TAccessoryPageData } from '@/shared/types/deprecated-types'

type Props = {
	accessories: TAccessoryPageData
	brands: BrandsItem[]
}

const AccessoriesPageContent = ({ accessories, brands }: Props) => {
	const { ...rest } = accessories

	return (
		<>
			<AccessoriesPage accessories={rest} brands={brands} />
		</>
	)
}

export function AccessoriesClient({ accessories, brands }: Props) {
	return <AccessoriesPageContent accessories={accessories} brands={brands} />
}
